'use strict';
const $ = require('jquery');

/*
 From https://www.ups.com/worldshiphelp/WS16/ENU/AppHelp/Codes/Countries_Territories_Requiring_Postal_Codes.htm
 Not all of these are actual countries, but should be covered by their parent state.
 */
const REQUIRES_POSTCODE = new Set([
    'DZ','AR','AM','AU','AT','AZ','A2','BD','BY','BE','BA','BR','BN','BG','CA',
    'IC','CN','HR','CY','CZ','DK','EN','EE','FO','FI','FR','GE','DE','GR','GL',
    'GU','GG','HO','HU','IN','ID','IL','IT','JP','JE','KZ','KR','KO','KG','LV',
    'LI','LT','LU','MK','MG','M3','MY','MH','MQ','YT','MX','MN','ME','NL','NZ',
    'NB','NO','PK','PH','PL','PO','PT','PR','RE','RU','SA','SF','CS','SG','SK',
    'SI','ZA','ES','LK','NT','SX','UV','VL','SE','CH','TW','TJ','TH','TU','TN',
    'TR','TM','VI','UA','GB','US','UY','UZ','VA','VN','WL','YA'
]);

function onCountryChange(event) {
    let zipField = $(event.target).closest('form').find("[name$='postal_code']");
    let zipLabel = zipField.siblings('label');

    if (REQUIRES_POSTCODE.has(event.target.value)) {
        zipLabel.text(zipLabel.text().replace(/([^*]):/, '$1 *:'));
        zipField.attr('required', 'required');
    } else {
        zipLabel.text(zipLabel.text().replace(' *', ''));
        zipField.attr('required', null);
    }

    if (zipField.hasClass('parsley-error')) {
        zipField.parsley().validate();
    }
}

export function initForms() {
    $("select[name$='country']").each(function() {
        $(this).on('input', onCountryChange);
        $(this).trigger('input');
    });

    $("input[name$='confirm_email']").each(function() {
        let emailField = $(this).closest('form').find("input[name$='email_address']");
        $(this).attr('data-parsley-equalto', '#' + emailField.attr('id'));

        let confirmField = $(this);
        emailField.parsley().on('field:validate', function() {
            confirmField.parsley().validate();
        });
    });
}
